import { CustomEvents, EncyclopediaMessage } from 'types';
import { delay } from 'utils';
import { ENCYCLOPEDIA } from 'constants/popups';
import { triggerMouseUp } from 'helpers/events';
import BaseManager from 'managers/base.manager';
import { Command } from './index';

const createCommand = <K extends keyof CustomEvents, T extends keyof EncyclopediaMessage>
  (trigger: K, command: T, data: Omit<Command<K, T>, 'trigger' | 'command'>): Command<K, T> => ({
    trigger,
    command,
    ...data,
  });

const COMMANDS = [
  createCommand('ENCYCLOPEDIA_ELEMENTS', 'elements', {
    prepare: () => ({
      elements: BaseManager.elements,
    }),
  }),
  createCommand('ENCYCLOPEDIA_TAGS', 'tags', {
    prepare: () => ({
      tags: BaseManager.tags,
    }),
  }),
  createCommand('ENCYCLOPEDIA_DESCRIPTIONS', 'descriptions', {
    prepare: () => ({
      descriptions: BaseManager.descriptions,
    }),
  }),

  createCommand('ENCYCLOPEDIA_SHOW_ITEM', 'showItem', {
    prepare: (_store, id) => ({ id }),
    callback: async ($store) => {
      triggerMouseUp(document.body, 'longpress');
      await delay(60);
      $store.dispatch('popupShow', ENCYCLOPEDIA);
    },
  }),
  createCommand('ENCYCLOPEDIA_SHOW_HELP', 'showHelp', {
    prepare: (_store, id) => ({ id }),
    callback: async ($store) => {
      await delay(60);
      $store.dispatch('popupShow', ENCYCLOPEDIA);
    },
  }),
  createCommand('ENCYCLOPEDIA_POPUP_HIDE', 'hiding', {
    callback: () => {
      if (document.activeElement && typeof (document.activeElement as any).blur === 'function') {
        (document.activeElement as HTMLElement).blur();
      }
    },
  }),
  createCommand('PROGRESS_RESET', 'reset', {
  }),
  createCommand('ENCYCLOPEDIA_MIX_BASE', 'mixBase', {
    prepare: (_store, elements) => ({ elements }),
  }),
  createCommand('ENCYCLOPEDIA_MIX_NEW', 'mixNew', {
    prepare: ($store, data) => {
      const exhausted = data.parents.filter((id) => $store.getters.elementIsExhausted(id));
      return { ...data, exhausted };
    },
  }),
  createCommand('ENCYCLOPEDIA_PROGRESS_ANALYZED', 'progress', {
    prepare: ($store) => {
      const exhausted = $store.getters.totalProgressElements.filter(
        (id) => $store.getters.elementIsExhausted(id),
      );

      return {
        history: $store.getters.history,
        progress: $store.getters.progress,
        timestamps: $store.getters.total,
        prime: $store.getters.prime,
        base: $store.getters.base,
        final: $store.getters.final,
        exhausted,
      };
    },
  }),
];

export default COMMANDS;
